import {DealLossMotiveDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createDealLossMotive(
    userData: Record<string, string>,
    dealLossMotive: Record<string, any>
) {
    try {
        const result = await DealLossMotiveDao.createDealLossMotive(userData.userToken, dealLossMotive);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
